import loadable from '@loadable/component';

export const AndroidcentralSiteWrapper = loadable(
  () => import(/* webpackChunkName: "androidcentral-site" */ './AndroidcentralSiteWrapper'),
);
